import { render, staticRenderFns } from "./OctOpticDiscView.vue?vue&type=template&id=6ec0297e"
import script from "./OctOpticDiscView.vue?vue&type=script&lang=js"
export * from "./OctOpticDiscView.vue?vue&type=script&lang=js"
import style0 from "./OctOpticDiscView.vue?vue&type=style&index=0&id=6ec0297e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports